import { MprcFilterLine } from "components/filter";
import { MprcButtonDropdownChecked } from "components/MprcButtonDropdownChecked";
import { KnowledgeSearchAttachVideoDuration, KnowledgeSearchOption, PublicationType } from "generated/CoreApi_v1";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { ChooseKnowledgePeriod } from "views/general/GlobalSearch/components/ChooseKnowledgePeriod";
import { ChooseKnowledgeRestrictionComponent } from "views/general/GlobalSearch/components/ChooseKnowledgeRestrictionComponent";
import { GlobalSearchOrderByComponent } from "views/general/GlobalSearch/components/GlobalSearchOrderByComponent";
import { KnowledgeSearchComponent } from "views/general/GlobalSearch/components/KnowledgeSearchComponent";
import { useGlobalSearch } from "views/general/GlobalSearch/GlobalSearchProvider";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export const FullVideoSearch = () => {

    const {
        searchResult,
        orderBy, setOrderBy,
        vFilters: filters, setVideoFilters: setFilters,
    } = useGlobalSearch();

    const { t } = useTranslation("shared");

    ///
    const renderFilter = useCallback(() => {
        return (
            <MprcFilterLine>
                <div>
                    <MprcButtonDropdownChecked
                        title={t("GlobalSearch.Filters.Knowledge.PublicationType.Title")}
                        selected={filters.publicationType}
                        onChange={(selected) => setFilters({ publicationType: selected })}
                        items={
                            [
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Any"), value: null },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Post"), value: PublicationType.Post },
                                { text: t("GlobalSearch.Filters.Knowledge.PublicationType.Question"), value: PublicationType.Question },
                            ]
                        }
                    />

                    <MprcButtonDropdownChecked
                        title={t("GlobalSearch.Filters.Knowledge.Duration.Title")}
                        selected={filters.videoDuration}
                        onChange={(selected) => setFilters({ videoDuration: selected })}
                        items={
                            [
                                { text: t("GlobalSearch.Filters.Knowledge.Duration.Any"), value: null },
                                { text: t("GlobalSearch.Filters.Knowledge.Duration.Until5"), value: KnowledgeSearchAttachVideoDuration.Until5 },
                                { text: t("GlobalSearch.Filters.Knowledge.Duration.Between5And20"), value: KnowledgeSearchAttachVideoDuration.Between5And20 },
                                { text: t("GlobalSearch.Filters.Knowledge.Duration.Between20And60"), value: KnowledgeSearchAttachVideoDuration.Between20And60 },
                                { text: t("GlobalSearch.Filters.Knowledge.Duration.OverOneHour"), value: KnowledgeSearchAttachVideoDuration.OverOneHour },
                            ]
                        }
                    />

                    <ChooseKnowledgePeriod
                        selectedOption={filters.period}
                        customStartDate={filters.periodStart}
                        customEndDate={filters.periodEnd}
                        onChange={
                            (selected, customStart, customEnd) => {
                                setFilters({ ...filters, period: selected, periodStart: customStart, periodEnd: customEnd });
                            }
                        }
                    />

                    <ChooseKnowledgeRestrictionComponent
                        selectedOption={filters.restriction}
                        onChange={(selected) => setFilters({ ...filters, restriction: selected })}
                    />

                </div>

                <GlobalSearchOrderByComponent
                    selectedOption={orderBy}
                    onChange={(orderBy) => setOrderBy(orderBy)}
                />

            </MprcFilterLine>
        );
    }, [filters, orderBy]);

    /////////////////////////////////////////////////////////////////////////////////////////////////

    return (
        <KnowledgeSearchComponent
            filters={filters}
            searchOption={KnowledgeSearchOption.Videos}
            showTitle={false}
            initialData={searchResult?.knowledgeVideos}
            renderFilter={renderFilter()}
            filterEmptyTextKey="shared:GlobalSearch.FullSearch.NoVideosFound"
            filterCountTextKey="shared:GlobalSearch.FullSearch.VideosFound"
        />
    );
};
